module.exports = __webpack_public_path__ + "media/images/index/clock-icon-8bbc5ea9c8719dc8501c983e0a95a647.png";